import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8 md:mb-10">
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-xl bg-primary/10">
          <Icon name="Zap" size={32} color="var(--color-primary)" />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
        Welcome to eCity Pro
      </h1>
      <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
        Enterprise project estimation and procurement management platform
      </p>
    </div>
  );
};

export default LoginHeader;